// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const BaseCarousel = require('client-v2/common/components/carousels/base')

const bem = BemEntity('TopCallToActionExperimentCSplitTrailing')

const slides = [
  /**
   * Slide images are assigned by index from the `img` directory:
   * `public/img/logged-out-landing/split-trailing-carousel/slide-${index}.jpg`
   */
  {
    // https://zpl.io/VqWNl9Y
    title: 'Find articles, images, videos, music',
    subtitle: 'Whether it’s on Mix or anywhere on the web.'
  },
  {
    // https://zpl.io/VDBLq7J
    title: 'Save them to a collection',
    subtitle: 'So you can view them later'
  },
  {
    // https://zpl.io/adpgr9e
    title: 'See what your friends are collecting',
    subtitle: 'Subscribe to their collections'
  }
]

function TopCallToActionExperimentCSplitTrailing(props) {
  return tag('div', {
    className: classNames(
      props.className,
      bem.block()
    )
  },
    tag(BaseCarousel, {
      // Values
      autoplay: true,
      autoplayInterval: 4000,
      className: bem.element('slider'),
      transitionMode: 'fade',
      wrapAround: true,
      // Callbacks
      // The dots position changes based on responsive design
      renderBottomCenterControls: renderDots,
      renderCenterLeftControls: null,
      renderCenterRightControls: renderDots
    },
      slides.map(renderSlide)
    )
  )
}

TopCallToActionExperimentCSplitTrailing.propTypes = {
  className: PropTypes.string
}

module.exports = TopCallToActionExperimentCSplitTrailing

function renderDots(carouselProps) {
  return BaseCarousel.renderDots({ bemEntity: bem, ...carouselProps })
}

function renderSlide(slideProps, index) {
  return tag('div', {
    key: `slide:${index}`,
    className: bem.element('slide', { index })
  },
    tag('div', {
      className: bem.element('title')
    },
      slideProps.title
    ),
    tag('div', {
      className: bem.element('subtitle')
    },
      slideProps.subtitle
    )
  )
}
